import "./footer.css";
import { Icon } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";

function Footer() {
  const todayDate = new Date();
  const moment = require("moment");
  const currentYear = moment(todayDate).format("YYYY");
  const location = useLocation();
  const currentPath = location.pathname;

  if (currentPath.includes("/updatehistory")) {
    return null;
  } else {
    return (
      <>
        <footer>
          <div className="footerMain">
            <div className="item1">
              <h3>INFORMATION</h3>
              <ul className="futLinks">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/login">Login</Link>
                </li>
              </ul>
            </div>
            <div className="item1">
              <h3>GET IN TOUCH</h3>
              <ul className="address">
                <li>
                  <Icon className="phone fas fa-phone" /> (949) 633-9944
                </li>
                <li>
                  <a href="mailto:coylemps@gmail.com">
                    <Icon className="envelope outline fas fa-map-marker-alt" />{" "}
                    info@collegiatesportsadvocate.com
                  </a>
                </li>
              </ul>
            </div>
            <div className="item1">
              <h3>FOLLOW US ON</h3>
              <ul className="socalMedia">
                <li>
                  <a
                    href="https://www.facebook.com/collegiatesportsadvocate/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon className="facebook f fab fa-facebook-f" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/csa_athletes"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon className="twitter fab fa-facebook-f" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/Collegiate_Sports_Advocate/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon className="instagram fab fa-instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCqkphc6NAwMU3FltuiT9HPA"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon className="youtube fab fa-youtube" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://open.spotify.com/show/5qvj1Y9Ja16R7YLD0jamZW"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon className="podcast fab fa-podcast" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div className="container">
            <center>
              <p className="copyRight">
                Copyright {currentYear} ©{" "}
                <span>Collegiate Sports Advocate LLC</span>, All Rights Reserved
              </p>
            </center>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
